export const ENCRYPTION_OBJECT_STORE = 'encryptionKeys';

// N!B! If you want to encrypt subfields (e.g. parent.field) you need to add the parent field to the list:
// 'parent', 'parent.field', 'parent.field2', etc.

// @todo: dbChanges.payload?, filesStorage.base64?
export const ENCRYPTED_FIELDS = {
  activities: ['alias?'],
  billing: ['address1', 'address2', 'billingEmail', 'billingName', 'city', 'phone', 'postalCode'],
  clients: ['address1', 'address2',
    'alias?', 'email', 'city', 'phone', 'postalCode', 'state', 'gender', 'clientName', 'birthDate'],
  clinics: ['address1', 'address2', 'billingEmail?', 'businessName', 'city', 'phone', 'postalCode', 'taxNumber'],
  data: ['notes'],
  filesUploading: ['file'],
  messages: ['authorName', 'message', 'messageHtml'],
  programs: ['programName', 'instructions', 'therapistInstructions', 'createdByUserName'],
  promptLevelTemplates: ['templateName'],
  sessionActivities: [
    'notes',
    'endGeolocation', 'endGeolocation.place', 'endGeolocation.accuracy', 'endGeolocation.latitude',
    'endGeolocation.longitude',
    'startGeolocation', 'startGeolocation.place', 'startGeolocation.accuracy', 'startGeolocation.latitude',
    'startGeolocation.longitude',
    'sessionName', 'signatures',
    'signatures.userName', 'signatures.url', 'signatures.geolocation',
    'signatures.geolocation.accuracy', 'signatures.geolocation.latitude', 'signatures.geolocation.longitude',
    'signatures.geolocation.place',
    'userName',
  ],
  sessionNoteTemplates: ['noteTemplateName', 'templateText'],
  sessions: ['createdByName', 'sessionName'],
  sub_programTargets: ['label'],
  sub_sessionPrograms: ['programName'],
  sub_sub_programBehaviourDataItems: ['label'], // @todo: other programs subs
  users: ['email', 'name'],
  usersClients: ['userName'],
  workflows: ['workflowName'],
  backupNotes: ['notes'],
};
